module.exports = __webpack_public_path__ + "img/human.073fb704.svg";